import * as React from "react";
import { PropsWithChildren } from "react";

import { isotype_svg } from "../../../assets/company_elements";
import {
  facebook_svg,
  instagram_svg,
  linkedin_svg,
  twitter_svg,
} from "../../../assets/socials_elements";
import { TypeCTA } from "../../../types/thecookies";
import DoNotMountComponent from "../../DoNotMountComponent/DoNotMountComponent";

export type PropsSocialLink = PropsWithChildren<{
  url: string;
  colorIcon?: "gray" | "black" | "white" | null | undefined;
  type?: TypeCTA | null | undefined;
  isDisable?: boolean | null | undefined;
}>;
const SocialLink: React.FC<PropsSocialLink> = (props: PropsSocialLink) => {
  const { url } = props;
  if (!url) return <DoNotMountComponent sms={"No existe Url"} />;
  const color = props.colorIcon ? props.colorIcon : "gray";
  const type: TypeCTA = props.type ? props.type : TypeCTA.LINK;
  const isDisable = !!props.isDisable;
  function navigateToUrl() {
    window.open(url, "_blank");
  }
  const getSocialMediaIcon = (url: string) => {
    if (url.includes("facebook.com")) {
      return facebook_svg;
    } else if (url.includes("twitter.com")) {
      return twitter_svg;
    } else if (url.includes("instagram.com")) {
      return instagram_svg;
    } else if (url.includes("linkedin.com")) {
      return linkedin_svg;
    } else {
      return isotype_svg;
    }
  };
  const icon = getSocialMediaIcon(url);
  switch (type) {
    case TypeCTA.LINK:
      return (
        <a
          href={url}
          className={`m-social-link m-social-link--${color} ${
            isDisable ? "m-social-link--disabled" : ""
          }`}
          title={`Ir a`}
          target={"_blank"}
          rel={"noopener noreferrer"}
        >
          {icon}
        </a>
      );
    case TypeCTA.BUTTON:
      return (
        <button
          disabled={isDisable}
          onClick={navigateToUrl}
          className={`m-social-link m-social-link--${color}`}
          title={`Ir a`}
        >
          {icon}
        </button>
      );
    default:
      return null;
  }
};

export default SocialLink;
